<template>
  <v-select label="common_name" :options="taxa"  @search="searchTaxa" v-model="selectedTaxon" :filterable="false" :placeholder="placeholder">
    <template slot="no-options">
      Search for Taxa
    </template>
    <template slot="option" slot-scope="taxon">
      <span class="notranslate" translate="no" v-if="taxon.common_name">{{ taxon.common_name }}</span>
      <br v-if="taxon.common_name" />
      <small class="notranslate" translate="no" v-if="taxon.scientific_name">{{ taxon.scientific_name }}</small>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'TaxonSelector',
  props: ['value', 'placeholder'],
  data: function(){
    return {
      taxa: [],
      selectedTaxon: this.value ? this.value : null,
    };
  },
  mounted: function(){

  },
  computed:{

  },
  methods:{
      searchTaxa: function(search, loading){
        loading(true);
        var target = this;
        this.API({
          endpoint: 'taxa',
          querystring: "&search="+search,
          funcThen: function(response){
            target.taxa = response.data.taxa;
          },
          funcAfterThen: function(){
            loading(false);
          }
        });
      },
  },
  watch: {
    'selectedTaxon': function(val){
      this.$emit('input', this.selectedTaxon);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/TaxonSelector.vue